import OverviewPage from 'pages/app/LCMS/Overview';
import NotificationsPage from 'pages/app/LCMS/Notifications';
import CourseCombinePage from 'pages/app/LCMS/CourseCombine';
import CoursesPage from 'pages/app/LCMS/Courses';
import CreateCoursePage from 'pages/app/LCMS/Courses/CreateCourse';
import DetailCoursePage from 'pages/app/LCMS/Courses/DetailCourse';
import CoursePlanPage from 'pages/app/LCMS/CoursePlan';
import CreateCoursePlanPage from 'pages/app/LCMS/CoursePlan/CreateCoursePlan';
import DetailCoursePlanPage from 'pages/app/LCMS/CoursePlan/DetailCoursePlan';
import DetailCourseCombinePage from 'pages/app/LCMS/CourseCombine/DetailCourseCombine';
import CourseCombineComparePage from 'pages/app/LCMS/CourseCombine/CompareCourseCombine';
import EditCoursePlanPage from 'pages/app/LCMS/CoursePlan/EditCoursePlan';

export const pathnames = {
  overview: '/app/lcms/overview',
  courses: '/app/lcms/courses',
  createCourses: '/app/lcms/courses/add',
  editCourses: '/app/lcms/courses/edit/:id',
  detailCourses: '/app/lcms/courses/:id',
  notifications: '/app/lcms/notifications',
  courseCombineTNA: '/app/lcms/course-combine',
  courseCombineTNADetail: '/app/lcms/course-combine/:id',
  courseCombineTNACompare: '/app/lcms/course-combine/compare',
  coursePlan: '/app/lcms/course-plan',
  createCoursePlan: '/app/lcms/course-plan/add',
  editCoursePlan: '/app/lcms/course-plan/edit/:id',
  detailCoursePlan: '/app/lcms/course-plan/:id'
};

const LCMSRoutes = [
  {
    path: pathnames.overview,
    element: <OverviewPage />
  },
  {
    path: pathnames.notifications,
    element: <NotificationsPage />
  },
  {
    path: pathnames.courses,
    element: <CoursesPage />
  },
  {
    path: pathnames.createCourses,
    element: <CreateCoursePage />
  },
  {
    path: pathnames.editCourses,
    element: <CreateCoursePage />
  },
  {
    path: pathnames.detailCourses,
    element: <DetailCoursePage />
  },
  {
    path: pathnames.courseCombineTNA,
    element: <CourseCombinePage />
  },
  {
    path: pathnames.courseCombineTNADetail,
    element: <DetailCourseCombinePage />
  },
  {
    path: pathnames.courseCombineTNACompare,
    element: <CourseCombineComparePage />
  },
  {
    path: pathnames.coursePlan,
    element: <CoursePlanPage />
  },
  {
    path: pathnames.createCoursePlan,
    element: <CreateCoursePlanPage />
  },
  {
    path: pathnames.editCoursePlan,
    element: <EditCoursePlanPage />
  },
  {
    path: pathnames.detailCoursePlan,
    element: <DetailCoursePlanPage />
  }
];

export default LCMSRoutes;
